class FixedAspectRatioImg {
	/**
	 * @type {HTMLImageElement|null}
	 */
	img = null;
	aspectRatio = 1;

	constructor(img) {
		this.img = img;

		if (this.img) {
			this.aspectRatio = parseInt(this.img.getAttribute("height")) / parseInt(this.img.getAttribute("width"));
		}
	}

	/**
	 * @return {number}
	 */
	getRealHeight() {
		return Math.round(this.img.offsetWidth * this.aspectRatio);
	}

}

export default FixedAspectRatioImg;
